"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplePriceOracleFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousPriceMantissa",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "requestedPriceMantissa",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newPriceMantissa",
                type: "uint256",
            },
        ],
        name: "PricePosted",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "assetPrices",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "getUnderlyingPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isPriceOracle",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "setDirectPrice",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "underlyingPriceMantissa",
                type: "uint256",
            },
        ],
        name: "setUnderlyingPrice",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class SimplePriceOracleFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SimplePriceOracleFactory = SimplePriceOracleFactory;
SimplePriceOracleFactory.bytecode = _bytecode;
SimplePriceOracleFactory.abi = _abi;
//# sourceMappingURL=SimplePriceOracleFactory.js.map